export default __webpack_public_path__ + "static/media/unsere_haeuser_web-sm@1x.91c82a69.webp";